import React, { Component } from 'react'
import PropTypes from 'prop-types'
import sortBy from 'lodash/sortBy'
import './style.css'

export default class ApplicationQuickAccessMenu extends Component {
  static propTypes = {
    applications: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        application_family: PropTypes.number.isRequired,
        application_type: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        is_published: PropTypes.bool.isRequired,
        order: PropTypes.number.isRequired,
        widget: PropTypes.number.isRequired,
        product: PropTypes.number
      })
    ).isRequired,
    isActiveApplication: PropTypes.func.isRequired,
    popLastBreadcrumbElement: PropTypes.func.isRequired,
    redirectToApplication: PropTypes.func.isRequired
  }

  redirectToApplication = (id, name) => () => {
    if (!this.props.isActiveApplication(id)) {
      const isPortal = true
      // Element should be popped before redirection
      this.props.popLastBreadcrumbElement()
      this.props.redirectToApplication(id, name, isPortal)
    }
  }

  render () {
    return (
      <div className='app-quick-access-menu-container'>
        <p className='app-quick-access-text app-quick-access-title'>Nos services</p>
        {
          sortBy(this.props.applications, 'name').map(app =>
            <p
              className='app-quick-access-text app-quick-access-item'
              style={
                this.props.isActiveApplication(app.id)
                  ? {fontWeight: 600, textDecoration: 'underline'}
                  : null
              }
              key={app.id}
              onClick={this.redirectToApplication(app.id, app.name)}
            >
              {app.name}
            </p>
          )
        }
      </div>
    )
  }
}
